import { HeadingOne } from 'Common/Custom/HeadingOne';
import PageBody from 'Common/Custom/PageBody';
import React, { useState } from 'react'
import WeeklyHolidayList from './components/WeeklyHolidayList';
import ManageWeekHoliday from './components/ManageWeekHoliday';
import { useRoleVerify } from 'Common/RoleVerify';

const ManageWeekHolidays = () => {
    const [refreshTrigger, setRefreshTrigger] = useState(false);
    const canShowAction = useRoleVerify("", ["can_edit", "can_access"]);

    const onUpdateSuccess = () => {
        setRefreshTrigger(prev => !prev);
    };

    return (
        <PageBody
            card={false}
            headerchildren={
                <HeadingOne>Weekly Holiday</HeadingOne>
            }>

            {canShowAction && (
                <div className="card">
                    <div className='card-body'>
                        <div className="row g-3">
                            <div className='col-12'>
                                <ManageWeekHoliday
                                    onSuccess={onUpdateSuccess}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <div className="card">
                <div className='card-body'>
                    <div className="row g-3">
                        <div className='col-12'>
                            <WeeklyHolidayList
                                refreshTrigger={refreshTrigger}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </PageBody>
    )
}


export default ManageWeekHolidays;
